import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { fromPairs, map } from 'lodash-es';

@Injectable()
export class FuseTailwindService
{
    private _tailwindConfig: ReplaySubject<any> = new ReplaySubject<any>(1);

    /**
     * Constructor
     */
    constructor()
    {
        // Prepare the config object
        const config: any = {
            breakpoints: {},
            themes: {}
        };

        // Try to extract config from CSS custom properties in the document
        // This is the modern approach for Tailwind v3
        try {
            const computedStyle = getComputedStyle(document.documentElement);
            
            // Get breakpoints from CSS custom properties if defined
            const breakpoints = ['sm', 'md', 'lg', 'xl', '2xl'];
            breakpoints.forEach(bp => {
                const value = computedStyle.getPropertyValue(`--breakpoint-${bp}`).trim();
                if (value) {
                    config.breakpoints[bp] = value;
                }
            });

            // Set default breakpoints if none found (matching tailwind.config.js)
            if (Object.keys(config.breakpoints).length === 0) {
                config.breakpoints = {
                    sm: '(min-width: 600px)',
                    md: '(min-width: 960px)',
                    lg: '(min-width: 1280px)',
                    xl: '(min-width: 1440px)'
                };
            }

            // Default themes config (can be extended)
            config.themes = {
                default: { id: 'default' }
            };

        } catch (error) {
            console.warn('FuseTailwindService: Could not extract Tailwind config from CSS', error);
            
            // Provide fallback config
            config.breakpoints = {
                sm: '(min-width: 600px)',
                md: '(min-width: 960px)',
                lg: '(min-width: 1280px)',
                xl: '(min-width: 1440px)'
            };
            config.themes = {
                default: { id: 'default' }
            };
        }

        // Execute the observable with the config
        this._tailwindConfig.next(config);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for _tailwindConfig
     */
    get tailwindConfig$(): Observable<any>
    {
        return this._tailwindConfig.asObservable();
    }
}
